<template>
  <div>
    <h5 class="mb-8">
      میتوانید از نقشه زیر قیمت پیک برای هر محدوده را تعیین کنید.
    </h5>
    <vs-row>
      <!-- <div class="tbl-cont">
        <table>
          <tr>
            <th style="border-left: 0">نام محدوده</th>
            <th>قیمت (ریال)</th>
          </tr>
          <tr v-for="item in polygons" :key="item.id">
            <td>
              {{ item.title }}
            </td>
            <td style="border-left: 1px solid forestgreen">
              <vs-button
                v-if="!getProviderDeliveryFee(item.id)"
                @click="polygonClicked(item)"
                color="primary"
                size="small"
                class="button"
                >انتخاب قیمت</vs-button
              >
              <div v-else class="row">
                <p class="table-value">
                  {{ getProviderDeliveryFee(item.id) }}
                </p>
                <vs-button
                  @click="polygonClicked(item)"
                  color="primary"
                  type="filled"
                  size="small"
                  icon-pack="feather"
                  icon="icon-edit"
                />
              </div>
            </td>
          </tr>
        </table>
      </div> -->
      <div class="map-pic-cont">
        <div id="neshanmap">
          <p v-html="htmlContent" polygonClicked="polygonClicked"></p>
        </div>
      </div>
    </vs-row>

    <vs-popup v-if="deliveryPriceVisible" title="تعیین قیمت محدوده" :active.sync="deliveryPriceVisible">
      <delivery-cost :selectedZone="selectedZone" :selectedFee="selectedFee" @itemAdded="itemAdded"
        @itemUpdated="itemUpdated" @itemDeleted="itemDeleted" />
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DeliveryCost from "./DeliveryCost.vue";
import providerApiService from "../../services/api/ProviderApiService";
import MapHtml from "./Map.html";
import { isArray } from 'lodash';

export default {
  name: "Delivery",
  components: {
    DeliveryCost,
  },
  data() {
    return {
      deliveryPriceVisible: false,
      selectedZone: null,
      selectedFee: null,
      polygons: [],
      providerDeliveryFees: [],
      name: "Amir",
      greet: "Hello, ",
      htmlContent: MapHtml,
      mapInitialized: false,
      // component: MapComponent,
    };
  },
  watch: {
    propertyAAndPropertyB(newVal) {
      const [newPropertyA, newPropertyB] = newVal.split('|');
      const polygons = JSON.parse(newPropertyA);
      const providerDeliveryFees = JSON.parse(newPropertyB);
      if ((polygons && polygons.length > 0) && (providerDeliveryFees && providerDeliveryFees.length > 0)) {
        this.polygons = polygons.map(item => {
          let selected = item;
          providerDeliveryFees.forEach(element => {
            if (item.id === element.zone) {
              selected = { ...item, feeId: element.id, fee: element.fee };
            }
          });

          return selected;
        });
        this.executeMapScript(this.polygons);
      }
    },
  },
  methods: {
    itemUpdated(deliveryFeeItem) {
      this.providerDeliveryFees.forEach((element) => {
        if (element.id === deliveryFeeItem.id) {
          element.fee = deliveryFeeItem.fee;
        }
      });
      this.deliveryPriceVisible = false;
    },
    itemAdded(deliveryFeeItem) {
      this.providerDeliveryFees.push(deliveryFeeItem);
      this.deliveryPriceVisible = false;
    },
    itemDeleted(deliveryFeeItem) {
      this.providerDeliveryFees = this.providerDeliveryFees.filter(
        (element) => element.id !== deliveryFeeItem.id
      );
      this.deliveryPriceVisible = false;
    },
    polygonClicked(event) {
      const item = event.detail;
      this.selectedFee = null;
      this.providerDeliveryFees.forEach((element) => {
        if (element.zone === item.id) {
          this.selectedFee = element;
          return;
        }
      });
      this.selectedZone = item;
      this.deliveryPriceVisible = true;
    },
    getAllPolygons() {
      providerApiService.getAllMapPolygons().then((result) => {
        this.polygons = result.data;
        this.getProviderDeliveryFees();
      });
    },
    getProviderDeliveryFees() {
      providerApiService
        .getProviderDeliveryFees(this.currentProvider.id)
        .then((result) => {
          if (isArray(result.data) && result.data.length > 0) {
            this.providerDeliveryFees = result.data;
          } else {
            this.executeMapScript(this.polygons);
          }
        });
    },
    getProviderDeliveryFee(zoneId) {
      const item = this.providerDeliveryFees.find(
        (element) => element.zone === zoneId
      );
      if (item) {
        if (+item.fee > 0) {
          return item.fee.toString().splitNumberFormat().numberFormat();
        }
        if (+item.fee === 0) {
          return "رایگان";
        }
        return null;
      }
      return null;
    },
    executeMapScript(polygonsCoordinates) {
      /**
       * Run map script for displaying polygons
       */
      if (!this.mapInitialized) {
        this.runScript(1, polygonsCoordinates);
        this.mapInitialized = true;
      }
    },
    executeLeafletScript() {
      /**
       * Run leaflet script
       */
      this.runScript(0);
    },
    runScript(i, polygonsCoordinates) {
      let container = document.getElementById("neshanmap");
      let scriptsTags = container.getElementsByTagName("script");
      let newScriptTag = document.createElement("script");
      newScriptTag.async = true;
      newScriptTag.type = "text/javascript";
      if (polygonsCoordinates) {
        const text = `
            var latlngs = ${JSON.stringify(polygonsCoordinates)};
            latlngs.forEach(function (item, index) {
              var polygon = L.polygon(item.coordinates, { color: item.feeId ? "green" : "grey" }).addTo(myMap);
              polygon.on('click', function (e) {
                window.polygonEvent = new CustomEvent("polygonClicked", { 'detail': item });
                window.dispatchEvent(window.polygonEvent);
              });
            })
          `;
        newScriptTag.text = scriptsTags[i].text + "\n" + text;
      }
      if (scriptsTags[i].src) {
        newScriptTag.src = scriptsTags[i].src;
      }
      document.head.appendChild(newScriptTag);
    },
  },
  mounted() {
    this.getAllPolygons();
    this.executeLeafletScript();
    window.addEventListener("polygonClicked", this.polygonClicked);
  },
  destroyed() {
    window.removeEventListener("polygonClicked", this.polygonClicked);
  },
  computed: {
    propertyAAndPropertyB() {
      return `${JSON.stringify(this.polygons)}|${JSON.stringify(this.providerDeliveryFees)}`;
    },
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
};
</script>

<style scoped lang="scss">
.title {
  color: black;
  font-weight: bold;
}

.fee {
  color: gray;
}

.tbl-cont {
  display: flex;
  margin-bottom: 50px;
}

table {
  width: 400px;
  border-spacing: 0;
}

th {
  text-align: center;
  border: 1px solid forestgreen;
  font-size: 1rem;
  padding: 10px 0;
}

td {
  text-align: center;
  padding: 10px 0;
  border-bottom: 1px solid forestgreen;
  border-left: 1px solid forestgreen;
}

button {
  margin: auto;
}

.map-pic-cont {
  flex: 1;
  margin: 0 30px;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 10px;
}

.table-value {
  flex: 1;
}
</style>
